import { useAnalyticsContext } from '@llt-frontend/react-analytics-context';

// Exports
// -------

export default function useAppContext() {
  return {
    analyticsContext: useAnalyticsContext(),
  };
}
